import React from 'react'

import { COLORS } from '~/common/globalStyles'
import { ProjectType } from '~/common/types/graphql'
import Icon from '~/views/components/ui/Icon'
import IconButton from '~/views/components/ui/IconButton'
import { useRouter } from 'next/router'
import { useStaticLabels } from 'shared/hooks/use-static-labels'
import {
  DrawerHeaderContainerAssign,
  DrawerHeaderAssignTask,
  DrawerHeaderDataContainer,
  DrawerHeaderProjectData,
  DrawerHeaderContainer,
  DrawerHeaderTitle,
  DrawerHeaderIcon,
  DrawerHeaderSubtitle,
  DrawerHeaderDescription,
} from './Styled'

interface DrawHeaderProps {
  onClose?(): void
  title: string
  subtitle?: string
  imageUrl: string
  showAssigner?: boolean
  project?: ProjectType
  description?: string
}

const DrawerHeader: React.FC<DrawHeaderProps> = ({
  onClose,
  title,
  subtitle,
  imageUrl,
  showAssigner,
  project,
  description,
}) => {
  const [getCommonLabel] = useStaticLabels(['common'])
  const router = useRouter()
  const { integration } = router.query
  const openApiIntegration = integration === 'open_api'

  return (
    <React.Fragment>
      {showAssigner && project ? (
        <DrawerHeaderContainerAssign>
          <div
            style={{
              display: 'flex',
              alignItems: 'left',
              flexDirection: 'column',
            }}
          >
            <DrawerHeaderAssignTask>
              {getCommonLabel('task')}: {title}
            </DrawerHeaderAssignTask>
            <DrawerHeaderDataContainer>
              <DrawerHeaderProjectData>
                {getCommonLabel('project')}: {project.name}
              </DrawerHeaderProjectData>
              <DrawerHeaderProjectData>
                {project.pmDisplayRole}: {project?.projectManager?.firstName}{' '}
                {project?.projectManager?.lastName}
              </DrawerHeaderProjectData>
            </DrawerHeaderDataContainer>
          </div>
          <IconButton onClick={onClose} data-testid="close-drawer" size="large">
            <Icon
              name="cancel"
              width="24px"
              color={COLORS.lightGray as keyof typeof COLORS}
            />
          </IconButton>
        </DrawerHeaderContainerAssign>
      ) : (
        <DrawerHeaderContainer>
          <DrawerHeaderTitle className="drawer-header-title">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {imageUrl && !openApiIntegration ? (
                <DrawerHeaderIcon imageUrl={imageUrl} />
              ) : null}
              {title}
            </div>
            <IconButton
              onClick={onClose}
              data-testid="close-drawer"
              size="large"
            >
              <Icon name="closeV2" width="10px" color="black" />
            </IconButton>
          </DrawerHeaderTitle>
          {subtitle && <DrawerHeaderSubtitle>{subtitle}</DrawerHeaderSubtitle>}
          {description && (
            <DrawerHeaderDescription>{description}</DrawerHeaderDescription>
          )}
        </DrawerHeaderContainer>
      )}
    </React.Fragment>
  )
}

export default DrawerHeader
